import type { IconDefinition } from '@fortawesome/fontawesome-svg-core';

import { faAddressCard as addressCard } from '@fortawesome/pro-light-svg-icons/faAddressCard';
import { faAngleDown as angleDown } from '@fortawesome/pro-light-svg-icons/faAngleDown';
import { faAnglesLeft as anglesLeft } from '@fortawesome/pro-light-svg-icons/faAnglesLeft';
import { faAnglesRight as anglesRight } from '@fortawesome/pro-light-svg-icons/faAnglesRight';
import { faArrowUpRightFromSquare as arrowUpRightFromSquare } from '@fortawesome/pro-light-svg-icons/faArrowUpRightFromSquare';
import { faArrowsRotate as arrowsRotate } from '@fortawesome/pro-light-svg-icons/faArrowsRotate';
import { faAt as at } from '@fortawesome/pro-light-svg-icons/faAt';
import { faBadgePercent as badgePercent } from '@fortawesome/pro-light-svg-icons/faBadgePercent';
import { faBarsProgress as barsProgress } from '@fortawesome/pro-light-svg-icons/faBarsProgress';
import { faBell as bell } from '@fortawesome/pro-light-svg-icons/faBell';
import { faBlog as blog } from '@fortawesome/pro-light-svg-icons/faBlog';
import { faBookOpen as bookOpen } from '@fortawesome/pro-light-svg-icons/faBookOpen';
import { faBookUser as bookUser } from '@fortawesome/pro-light-svg-icons/faBookUser';
import { faBoxOpen as boxOpen } from '@fortawesome/pro-light-svg-icons/faBoxOpen';
import { faBriefcaseBlank as briefcaseBlank } from '@fortawesome/pro-light-svg-icons/faBriefcaseBlank';
import { faBrowser as browser } from '@fortawesome/pro-light-svg-icons/faBrowser';
import { faBullhorn as bullhorn } from '@fortawesome/pro-light-svg-icons/faBullhorn';
import { faBullseyeArrow as bullseyeArrow } from '@fortawesome/pro-light-svg-icons/faBullseyeArrow';
import { faCalendarRange as calendarRange } from '@fortawesome/pro-light-svg-icons/faCalendarRange';
import { faCalendarStar as calendarStar } from '@fortawesome/pro-light-svg-icons/faCalendarStar';
import { faChevronLeft as chevronLeft } from '@fortawesome/pro-light-svg-icons/faChevronLeft';
import { faCircleCheck as circleCheck } from '@fortawesome/pro-light-svg-icons/faCircleCheck';
import { faCircleExclamation as circleExclamation } from '@fortawesome/pro-light-svg-icons/faCircleExclamation';
import { faClock as clock } from '@fortawesome/pro-light-svg-icons/faClock';
import { faClover as clover } from '@fortawesome/pro-light-svg-icons/faClover';
import { faCode as code } from '@fortawesome/pro-light-svg-icons/faCode';
import { faCoins as coins } from '@fortawesome/pro-light-svg-icons/faCoins';
import { faCopy as copy } from '@fortawesome/pro-light-svg-icons/faCopy';
import { faDatabase as database } from '@fortawesome/pro-light-svg-icons/faDatabase';
import { faDisplay as display } from '@fortawesome/pro-light-svg-icons/faDisplay';
import { faDollarSign as dollarSign } from '@fortawesome/pro-light-svg-icons/faDollarSign';
import { faDownload as download } from '@fortawesome/pro-light-svg-icons/faDownload';
import { faEarthAfrica as earthAfrica } from '@fortawesome/pro-light-svg-icons/faEarthAfrica';
import { faEarthAmericas as earthAmericas } from '@fortawesome/pro-light-svg-icons/faEarthAmericas';
import { faEarthAsia as earthAsia } from '@fortawesome/pro-light-svg-icons/faEarthAsia';
import { faEarthEurope as earthEurope } from '@fortawesome/pro-light-svg-icons/faEarthEurope';
import { faEarthOceania as earthOceania } from '@fortawesome/pro-light-svg-icons/faEarthOceania';
import { faEnvelope as envelope } from '@fortawesome/pro-light-svg-icons/faEnvelope';
import { faEuroSign as euroSign } from '@fortawesome/pro-light-svg-icons/faEuroSign';
import { faFiles as files } from '@fortawesome/pro-light-svg-icons/faFiles';
import { faFilter as filter } from '@fortawesome/pro-light-svg-icons/faFilter';
import { faFilterSlash as filterSlash } from '@fortawesome/pro-light-svg-icons/faFilterSlash';
import { faFireFlameCurved as fireFlameCurved } from '@fortawesome/pro-light-svg-icons/faFireFlameCurved';
import { faGear as gear } from '@fortawesome/pro-light-svg-icons/faGear';
import { faGenderless as genderless } from '@fortawesome/pro-light-svg-icons/faGenderless';
import { faGlobe as globe } from '@fortawesome/pro-light-svg-icons/faGlobe';
import { faGlobeWifi as globeWifi } from '@fortawesome/pro-light-svg-icons/faGlobeWifi';
import { faHandshakeSimple as handshakeSimple } from '@fortawesome/pro-light-svg-icons/faHandshakeSimple';
import { faHeart as heart } from '@fortawesome/pro-light-svg-icons/faHeart';
import { faHistory as history } from '@fortawesome/pro-light-svg-icons/faHistory';
import { faIdBadge as idBadge } from '@fortawesome/pro-light-svg-icons/faIdBadge';
import { faImageCirclePlus as imageCirclePlus } from '@fortawesome/pro-light-svg-icons/faImageCirclePlus';
import { faImageCircleXmark as imageCircleXmark } from '@fortawesome/pro-light-svg-icons/faImageCircleXmark';
import { faImages as images } from '@fortawesome/pro-light-svg-icons/faImages';
import { faInboxIn as inboxIn } from '@fortawesome/pro-light-svg-icons/faInboxIn';
import { faInboxOut as inboxOut } from '@fortawesome/pro-light-svg-icons/faInboxOut';
import { faLanguage as language } from '@fortawesome/pro-light-svg-icons/faLanguage';
import { faLink as link } from '@fortawesome/pro-light-svg-icons/faLink';
import { faListOl as listOl } from '@fortawesome/pro-light-svg-icons/faListOl';
import { faLock as lock } from '@fortawesome/pro-light-svg-icons/faLock';
import { faMagnifyingGlass as magnifyingGlass } from '@fortawesome/pro-light-svg-icons/faMagnifyingGlass';
import { faMars as mars } from '@fortawesome/pro-light-svg-icons/faMars';
import { faMarsAndVenus as marsAndVenus } from '@fortawesome/pro-light-svg-icons/faMarsAndVenus';
import { faMarsDouble as marsDouble } from '@fortawesome/pro-light-svg-icons/faMarsDouble';
import { faMedal as medal } from '@fortawesome/pro-light-svg-icons/faMedal';
import { faMercury as mercury } from '@fortawesome/pro-light-svg-icons/faMercury';
import { faMessageImage as messageImage } from '@fortawesome/pro-light-svg-icons/faMessageImage';
import { faMessageLines as messageLines } from '@fortawesome/pro-light-svg-icons/faMessageLines';
import { faMessagePen as messagePen } from '@fortawesome/pro-light-svg-icons/faMessagePen';
import { faMessagePlus as messagePlus } from '@fortawesome/pro-light-svg-icons/faMessagePlus';
import { faMessageSlash as messageSlash } from '@fortawesome/pro-light-svg-icons/faMessageSlash';
import { faMessageXmark as messageXmark } from '@fortawesome/pro-light-svg-icons/faMessageXmark';
import { faMessages as messages } from '@fortawesome/pro-light-svg-icons/faMessages';
import { faMessagesDollar as messagesDollar } from '@fortawesome/pro-light-svg-icons/faMessagesDollar';
import { faMobile as mobile } from '@fortawesome/pro-light-svg-icons/faMobile';
import { faMoneyBill as moneyBill } from '@fortawesome/pro-light-svg-icons/faMoneyBill';
import { faMoonStars as moonStars } from '@fortawesome/pro-light-svg-icons/faMoonStars';
import { faNote as note } from '@fortawesome/pro-light-svg-icons/faNote';
import { faPaperPlane as paperPlane } from '@fortawesome/pro-light-svg-icons/faPaperPlane';
import { faPeopleArrows as peopleArrows } from '@fortawesome/pro-light-svg-icons/faPeopleArrows';
import { faPeopleGroup as peopleGroup } from '@fortawesome/pro-light-svg-icons/faPeopleGroup';
import { faPersonLimbsWide as personLimbsWide } from '@fortawesome/pro-light-svg-icons/faPersonLimbsWide';
import { faPersonRunning as personRunning } from '@fortawesome/pro-light-svg-icons/faPersonRunning';
import { faPhone as phone } from '@fortawesome/pro-light-svg-icons/faPhone';
import { faPlus as plus } from '@fortawesome/pro-light-svg-icons/faPlus';
import { faPoundSign as poundSign } from '@fortawesome/pro-light-svg-icons/faPoundSign';
import { faPuzzle as puzzle } from '@fortawesome/pro-light-svg-icons/faPuzzle';
import { faReceipt as receipt } from '@fortawesome/pro-light-svg-icons/faReceipt';
import { faRectangleAd as rectangleAd } from '@fortawesome/pro-light-svg-icons/faRectangleAd';
import { faRetweet as retweet } from '@fortawesome/pro-light-svg-icons/faRetweet';
import { faRightFromBracket as rightFromBracket } from '@fortawesome/pro-light-svg-icons/faRightFromBracket';
import { faRightToBracket as rightToBracket } from '@fortawesome/pro-light-svg-icons/faRightToBracket';
import { faRotate as rotate } from '@fortawesome/pro-light-svg-icons/faRotate';
import { faRotateLeft as rotateLeft } from '@fortawesome/pro-light-svg-icons/faRotateLeft';
import { faShareAlt as shareAlt } from '@fortawesome/pro-light-svg-icons/faShareAlt';
import { faShareNodes as shareNodes } from '@fortawesome/pro-light-svg-icons/faShareNodes';
import { faShield as shield } from '@fortawesome/pro-light-svg-icons/faShield';
import { faShieldCheck as shieldCheck } from '@fortawesome/pro-light-svg-icons/faShieldCheck';
import { faSnooze as snooze } from '@fortawesome/pro-light-svg-icons/faSnooze';
import { faSquare as square } from '@fortawesome/pro-light-svg-icons/faSquare';
import { faSquareCheck as squareCheck } from '@fortawesome/pro-light-svg-icons/faSquareCheck';
import { faSquareQuestion as squareQuestion } from '@fortawesome/pro-light-svg-icons/faSquareQuestion';
import { faSunBright as sunBright } from '@fortawesome/pro-light-svg-icons/faSunBright';
import { faTimer as timer } from '@fortawesome/pro-light-svg-icons/faTimer';
import { faTransgender as transgender } from '@fortawesome/pro-light-svg-icons/faTransgender';
import { faTrash as trash } from '@fortawesome/pro-light-svg-icons/faTrash';
import { faTriangleExclamation as triangleExclamation } from '@fortawesome/pro-light-svg-icons/faTriangleExclamation';
import { faUserFriends as userFriends } from '@fortawesome/pro-light-svg-icons/faUserFriends';
import { faUserGroup as userGroup } from '@fortawesome/pro-light-svg-icons/faUserGroup';
import { faUserSecret as userSecret } from '@fortawesome/pro-light-svg-icons/faUserSecret';
import { faUserSlash as userSlash } from '@fortawesome/pro-light-svg-icons/faUserSlash';
import { faUsers as users } from '@fortawesome/pro-light-svg-icons/faUsers';
import { faUtensils as utensils } from '@fortawesome/pro-light-svg-icons/faUtensils';
import { faVenus as venus } from '@fortawesome/pro-light-svg-icons/faVenus';
import { faVenusDouble as venusDouble } from '@fortawesome/pro-light-svg-icons/faVenusDouble';
import { faVenusMars as venusMars } from '@fortawesome/pro-light-svg-icons/faVenusMars';
import { faWavePulse as wavePulse } from '@fortawesome/pro-light-svg-icons/faWavePulse';
import { faXmark as xmark } from '@fortawesome/pro-light-svg-icons/faXmark';

const icons: Record<string, IconDefinition> = {
  addressCard,
  angleDown,
  anglesLeft,
  anglesRight,
  arrowUpRightFromSquare,
  arrowsRotate,
  at,
  badgePercent,
  barsProgress,
  bell,
  blog,
  bookOpen,
  bookUser,
  boxOpen,
  briefcaseBlank,
  browser,
  bullhorn,
  bullseyeArrow,
  calendarRange,
  calendarStar,
  chevronLeft,
  circleCheck,
  circleExclamation,
  clock,
  clover,
  code,
  coins,
  copy,
  database,
  display,
  dollarSign,
  download,
  earthAfrica,
  earthAmericas,
  earthAsia,
  earthEurope,
  earthOceania,
  envelope,
  euroSign,
  files,
  filter,
  filterSlash,
  fireFlameCurved,
  gear,
  genderless,
  globe,
  globeWifi,
  handshakeSimple,
  heart,
  history,
  idBadge,
  imageCirclePlus,
  imageCircleXmark,
  images,
  inboxIn,
  inboxOut,
  language,
  link,
  listOl,
  lock,
  magnifyingGlass,
  mars,
  marsAndVenus,
  marsDouble,
  medal,
  mercury,
  messageImage,
  messageLines,
  messagePen,
  messagePlus,
  messageSlash,
  messageXmark,
  messages,
  messagesDollar,
  mobile,
  moneyBill,
  moonStars,
  note,
  paperPlane,
  peopleArrows,
  peopleGroup,
  personLimbsWide,
  personRunning,
  phone,
  plus,
  poundSign,
  puzzle,
  receipt,
  rectangleAd,
  retweet,
  rightFromBracket,
  rightToBracket,
  rotate,
  rotateLeft,
  shareAlt,
  shareNodes,
  shield,
  shieldCheck,
  snooze,
  square,
  squareCheck,
  squareQuestion,
  sunBright,
  timer,
  transgender,
  trash,
  triangleExclamation,
  userFriends,
  userGroup,
  userSecret,
  userSlash,
  users,
  utensils,
  venus,
  venusDouble,
  venusMars,
  wavePulse,
  xmark,
};

export default icons;
